module.exports = __webpack_public_path__ + "img/image98.0e94919d.png";